import React from 'react';
import AccusedInfo from './items/AccusedInfo';
//Función principal
const AudienceAccuseds = props => {
    //Tomo los props
    const { audience } = props;
    //Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">IMPUTADO/S</h6>
                </div>
                <div className="card-body">
                    <div className="row">
                        {
                            audience && audience.imputadoList ? (
                                audience.imputadoList.map((accused, index) => (
                                    <AccusedInfo
                                        key={`ai${accused.id}`}
                                        index={index}
                                        accused={ accused }
                                        audience={audience}
                                        canEdit={true}
                                    />
                                ))
                            ) : null
                        }
                    </div>
                    
                </div>
            </div>
        </div>
    );
};

export default AudienceAccuseds;